export default __webpack_public_path__ + "static/media/home-outline.796c50f5.svg";